import { useEffect, useState } from 'react';
import { useNCZIContext } from '../Services/NCZIContext';
import useNCZICommands from './useNCZICommands';
import {
	GetPatientDPNList,
	GetPatientDPNListParams,
} from '../Commands/GetPatientDPNList';
import apiClient from '../../../Services/ApiClient';
import { FinishedCommand } from '../Commands/Command';
import { NCZIEhrExtractEnvelope } from '../Interfaces/ncziTypes';
import { ElectronicDPNFilterValues } from '../Components/ElectronicDPN/Filter/ElectronicDPNFilter';

export default function useNCZIElectronicDPN() {
	const {
		patientDPNData, setPatientDPNData, setPatientDPNPage, patientIdentifier
	} = useNCZIContext();

	const { commands, execute } = useNCZICommands();

	const [listDPNCommandId, setListDPNCommandId] = useState<string | undefined>(undefined);
	const [loadingCommandId, setLoadingCommandId] = useState<string | undefined>(undefined);

	const fetchPatientElectronicDPNData = async (
		params: GetPatientDPNListParams,
	) => {
		const command = await obtainPatientElectronicDPNListData(params);
		setPatientDPNData(null);
		return command;
	};

	useEffect(() => {
		if (listDPNCommandId && !patientDPNData) {
			const command = commands[listDPNCommandId];
			if (command && command.state === 'done') {
				const finishedCommand = command as FinishedCommand;
				if (finishedCommand.result) {
					setPatientDPNData(finishedCommand.result as NCZIEhrExtractEnvelope);
				}
			}
		}
	}, [commands, listDPNCommandId]);

	const obtainPatientElectronicDPNListData = async (
		params: GetPatientDPNListParams,
	) => {
		const commandGetPatientDPNList = GetPatientDPNList(params);

		if (params?.page) {
			setPatientDPNPage(params.page);
		}
		const result = await execute(commandGetPatientDPNList);
		if (!('error' in result && result.error)) {
			setListDPNCommandId(result.id);
		}

		return result;
	};

	const handleLoadPatientDPNData = async (page: number = 1, filterValues?: ElectronicDPNFilterValues) => {
		if (patientIdentifier) {
			const command = await fetchPatientElectronicDPNData({
				patientCode: patientIdentifier,
				page,
				// includeHistory: filterValues?.includeHistory,
				includeCancelled: filterValues?.includeCancelled,
				withoutValidityEnd: filterValues?.withoutValidityEnd,
				createdFrom: filterValues?.createdFrom?.format('YYYY-MM-DD'),
				createdTo: filterValues?.createdTo?.format('YYYY-MM-DD'),
				endValidityFrom: filterValues?.endValidityFrom?.format('YYYY-MM-DD'),
				endValidityTo: filterValues?.endValidityTo?.format('YYYY-MM-DD'),
				startValidityFrom: filterValues?.startValidityFrom?.format('YYYY-MM-DD'),
				startValidityTo: filterValues?.startValidityTo?.format('YYYY-MM-DD'),
			});
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};

	const handleFakeLoadPatientDPNData = async () => {
		const { data: response } = await apiClient.get(
			'/nczi/message/dc0029e3-156e-458b-a607-1d6f8f81ebce/response',
		);
		setPatientDPNPage(1);
		setPatientDPNData(response.data);
	};

	return {
		handleLoadPatientDPNData,
		handleFakeLoadPatientDPNData,
		loadingCommandId
	};
}
